export default "__VITE_ASSET__4e182086__"